import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import stagingProductionReducer from "../features/pages/staging/stagingProductionSlice";
import masterPalleteReducer from "../features/pages/pallete/masterPalleteSlice";
import masterRakingReducer from "../features/pages/raking/masterRakingSlice";
import masterProductsReducer from "../features/pages/raking/masterProductsSlice";
import masterWarehouseReducer from "../features/pages/raking/warehouseSlice";
import dasboardReducer from "../features/pages/dashboard/dashboardSlice";


export const store = configureStore({
    reducer: {
        auth: authReducer,
        stagingProduction: stagingProductionReducer,
        masterPallete: masterPalleteReducer,
        masterRaking: masterRakingReducer,
        masterProducts: masterProductsReducer,
        masterWarehouses: masterWarehouseReducer,
        dashboard: dasboardReducer,
    },
});